import { tgxApi } from "../../../app/tgxApi";
import {
    getAuthorizationHeader,
    handleQueryError,
    handleQueryErrorAndSuccess
} from "../../../helpers/utils/RtkQueryUtils";
import { serialize } from "../../../helpers/utils/Utils";

export const cannedNotesApi = tgxApi.injectEndpoints({
    endpoints: (build) => ({
        getCannedNoteById: build.query({
            query: (id) => {
                return {
                    url: `/ajax/canned-note/${id}`,
                    method: 'GET',
                    headers: getAuthorizationHeader(),
                };
            },
            providesTags: ['cannedNoteById'],
            async onQueryStarted(_, { queryFulfilled }) {
                await handleQueryError(queryFulfilled)
            },
        }),
        updateCannedNote: build.mutation({
            query: ({ id, requestBody }) => {
                return {
                    url: `/ajax/update-canned-note/${id}`,
                    method: 'PUT',
                    headers: getAuthorizationHeader(),
                    body: requestBody
                };
            },
            invalidatesTags: ['cannedNotes', 'cannedNoteById', 'userAuditableInfo'],
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryErrorAndSuccess(queryFulfilled, "Updated", "Canned Note")
            },
        }),
        createCannedNote: build.mutation({
            query: (requestBody) => {
                return {
                    url: `/ajax/canned-notes/create`,
                    method: 'POST',
                    headers: getAuthorizationHeader(),
                    body: requestBody
                };
            },
            invalidatesTags: ['cannedNotes', 'userAuditableInfo'],
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryErrorAndSuccess(queryFulfilled, "Created", "Canned Note")
            },
        }),
        deleteCannedNote: build.mutation({
            query: (id) => {
                return {
                    url: `/ajax/canned-note/${id}`,
                    method: 'DELETE',
                    headers: getAuthorizationHeader(),
                };
            },
            invalidatesTags: ['cannedNotes'],
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryErrorAndSuccess(queryFulfilled, "Removed", "Canned Notes")
            },
        }),
        searchCannedNotes: build.query({
            query: (data) => {
                let paramData = serialize(data);
                return {
                    url: `/ajax/canned-notes?${paramData}`,
                    method: 'POST',
                    headers: getAuthorizationHeader()
                };
            },
            providesTags: ["cannedNotes"],
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryError(queryFulfilled)
            },
        }),


        deleteCannedNotesById: build.mutation({
            query: (id) => {
                return {
                    url: `/ajax/deleteCertificateNote/${id}`,
                    method: 'DELETE',
                    headers: getAuthorizationHeader()
                };
            },
            invalidatesTags: ['managementCompanies'],
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryErrorAndSuccess(queryFulfilled, "Deleted", "Notes");
            },
        }),

    }),
});


export const {
    useSearchCannedNotesQuery,
    useUpdateCannedNoteMutation,
    useGetCannedNoteByIdQuery,
    useDeleteCannedNoteMutation,
    useCreateCannedNoteMutation

} = cannedNotesApi;